module.exports = __webpack_public_path__ + "img/male_avatar.7cfd2e61.png";